/**
 * Which companies may download the Lao eTax Excel export
 * (components/admin/documents/lao-etax-export-dialog.vue).
 *
 *   Settings/laoEtax = {
 *     exportEnabled: { '<companyID>': true | false },
 *     defaultExportEnabled: true | false,
 *   }
 *
 * Resolution: the company's own entry, then defaultExportEnabled, then OFF.
 * Fails closed — an unreadable setting hides the button rather than showing it.
 *
 * Written ONLY by the callSetLaoEtaxExport function (engineers, from the
 * ตั้งค่า Lao eTax page). Settings/laoEtax has no client write rule, and that
 * callable can touch this one key and nothing else — companyEnv in the same
 * document decides which gateway real invoices go to.
 *
 * This is a product switch, not access control: everyone who can open the
 * documents table can already read the documents the file is built from.
 */

/**
 * @param {object} data       Settings/laoEtax document body ({} when absent)
 * @param {string} companyID
 * @returns {{ enabled: boolean, source: string }}
 */
export function exportEnabledFor(data, companyID) {
  const d = data || {};
  const cid = (companyID || "").toString().trim();
  const map = d.exportEnabled;
  if (cid && map && typeof map === "object" && Object.prototype.hasOwnProperty.call(map, cid)) {
    return { enabled: map[cid] === true, source: 'exportEnabled["' + cid + '"]' };
  }
  if (typeof d.defaultExportEnabled === "boolean") {
    return { enabled: d.defaultExportEnabled, source: "defaultExportEnabled" };
  }
  return { enabled: false, source: "ค่าเริ่มต้น (ปิด)" };
}

export async function resolveLaoExportEnabled(db, companyID) {
  try {
    const snap = await db.collection("Settings").doc("laoEtax").get();
    return exportEnabledFor(snap.exists ? snap.data() : {}, companyID).enabled;
  } catch (e) {
    console.error("resolveLaoExportEnabled: Settings/laoEtax read failed", e);
    return false;
  }
}
